import { TextField, FormControl, InputLabel, Select, MenuItem, Typography, Divider, Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import theme from './Theme';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface AddressFieldsProps {
  formData: PlaceFormData;
  errors: Record<string, string>;
  onChange: (name: string, value: any) => void;
}

const focusStyles = {
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': { borderColor: 'primary.main' },
    '&.Mui-focused fieldset': { borderWidth: 2, borderColor: 'primary.main' },
  },
};

export const AddressFields = ({ formData, errors, onChange }: AddressFieldsProps) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocationOnIcon sx={{ color: theme.palette.accent.main }} />
        Address Information
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <TextField
        label="Address"
        name="address"
        value={formData.address}
        onChange={(e) => onChange('address', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors.address}
        helperText={errors.address}
        sx={focusStyles}
      />
      <TextField
        label="City"
        name="city"
        value={formData.city}
        onChange={(e) => onChange('city', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors.city}
        helperText={errors.city}
        sx={focusStyles}
      />
      <TextField
        label="Zip"
        name="zip"
        value={formData.zip}
        onChange={(e) => onChange('zip', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors.zip}
        helperText={errors.zip}
        sx={focusStyles}
      />
      <FormControl fullWidth margin="normal" error={!!errors.country}>
        <InputLabel>Country</InputLabel>
        <Select
          value={formData.country}
          onChange={(e) => onChange('country', e.target.value)}
          label="Country"
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              '&:hover': { borderColor: 'primary.main' },
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: 2,
              borderColor: 'primary.main',
            },
          }}
        >
          <MenuItem value="Bulgaria">Bulgaria</MenuItem>
          <MenuItem value="USA">USA</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};
